// removed by extract-text-webpack-plugin
module.exports = {"component":"_29jUo8p0F81vB3k-xtQeyY","khImg":"qSKUWl4t5c4rMLnxvDQYm","khBox":"RZw7HIqqPhOZSwXySHwtj","gerul":"_3Rr0v8JfOGIeP8sUZCt5NO","gerLink":"_1ngcv11bm2_SqB2NzRD9Qe","border":"yzddjQKRmOvsCX1MqqdeA","jsdd":"_2v85bP0tEd_bFHR4rxbWv5","selt":"O6hyif8mfpoQsTPCN0vz","jsallshou":"_2kjSvC7KaxYk-dBEQIginK","img":"_15_xajnyZT0cEpcSFpNeU6","allTable":"_2tc5m0vLdNPiUDlky1f43y","bttn":"NldW9DJfcqlXiOl9JVceX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ClientDetails/ClientDetails.scss
 ** module id = 1055
 ** module chunks = 0
 **/